import { render, staticRenderFns } from "./ApproveApplication.vue?vue&type=template&id=3af48fbf&scoped=true"
import script from "./ApproveApplication.vue?vue&type=script&lang=js"
export * from "./ApproveApplication.vue?vue&type=script&lang=js"
import style0 from "./ApproveApplication.vue?vue&type=style&index=0&id=3af48fbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af48fbf",
  null
  
)

export default component.exports